import { createMuiTheme } from "@material-ui/core/styles";
import logoK from "./logo-k.svg";
import logoR from "./logo-r.svg";
import logoT from "./logo-t.svg";
import logoM from "./logo-m.svg";
import horizontalLogoTE from "./horizontal-logo-te.png";
import faviconK from "./favicon/favicon-k.ico";
import faviconR from "./favicon/favicon-r.png";
import faviconT from "./favicon/favicon-t.png";
import faviconTE from "./favicon/favicon-t.png";
import faviconM from "./favicon/favicon-m.ico";
import Poppins from "./fonts/poppins-v20-latin-regular.woff";
import RGerstner from "./fonts/RGerstner-Regular.ttf";
import Telecable from "./fonts/Telecable-Regular.ttf";
import WalsheimBold from "./fonts/Walsheim-Bold.ttf";
import WalsheimMedium from "./fonts/gt-walsheim-medium.ttf";

export const DOMAIN_K = ".euskaltel.com";
export const DOMAIN_R = ".mundo-r.com";
export const DOMAIN_TE = ".telecable.es";
export const DOMAIN_T = "empresas.telecable.es";
export const DOMAIN_M = ".masmovil.es";

export let domainTheme;
export let domain = window.location.hostname;

const isTsubdomain = (domain) => domain.split(".").slice(1).join(".") === DOMAIN_T;

export default function Theme() {
  var link =
    document.querySelector("link[rel*='icon']") ||
    document.createElement("link");
  link.type = "image/x-icon";
  link.rel = "shortcut icon";

  var theme;

  if (window.location.search.indexOf("forceMasMovil") !==-1) {
    domainTheme = DOMAIN_M;
    link.href = `${faviconM}`;
    theme = themes["m"];
  }
  else if (window.location.search.indexOf("forceTE") !==-1) {
    domainTheme = DOMAIN_TE;
    link.href = `${faviconTE}`;
    theme = themes["te"];
  }
  else if (window.location.search.indexOf("forceT") !==-1) {
    domainTheme = DOMAIN_T;
    link.href = `${faviconT}`;
    theme = themes["t"];
  }
  else if (domain.indexOf(DOMAIN_K) !== -1) {
    domainTheme = DOMAIN_K;
    link.href = `${faviconK}`;
    theme = themes["k"];
  } else if (domain.indexOf(DOMAIN_R) !== -1) {
    domainTheme = DOMAIN_R;
    link.href = `${faviconR}`;
    theme = themes["r"];
  }
  else if (isTsubdomain(domain)) {
    domainTheme = DOMAIN_T;
    link.href = `${faviconT}`;
    theme = themes["t"];
  }
   else if (domain.indexOf(DOMAIN_TE) !== -1) {
    domainTheme = DOMAIN_TE;
    link.href = `${faviconT}`;
    theme = themes["te"];
  } else if (domain.indexOf(DOMAIN_M) !== -1) {
    domainTheme = DOMAIN_M;
    link.href = `${faviconM}`;
    theme = themes["m"];
  } else {
    domainTheme = null;
    theme = themes["error"];
  }

  document.getElementsByTagName("head")[0].appendChild(link);
  return theme;
}

const themes = {
  k: createMuiTheme({
    sidebar: {
      width: 280, // The default value is 240
    },
    palette: {
      primary: { main: "#ff5800" },
      secondary: {
        contrastText: "#fff",
        main: "#ff5800",
      },
    },
    overrides: {
      MuiMenuItem: {
        root: {
          whiteSpace: "normal",
        },
      },
      MuiCssBaseline: {
        "@global": {
          "@font-face": {
            fontFamily: "Poppins",
            src: `local('Poppins'),url(${Poppins}) format('woff')` /* Legacy iOS */,
          },
          body: {
            fontFamily: "Poppins,sans-serif",
          },
          ".localeBar": {
            backgroundColor: "#1a1b1c",
            height: "30px",
            paddingTop: "3px",
          },
          ".loginHeader": {
            backgroundColor: "#ff5800",
          },
          ".logoHeader": {
            backgroundImage: `url(${logoK})`,
            backgroundSize: 180,
            width: 200,
          },
          ".login form .MuiCardActions-root": {
            margin: 50,
          },
          ".btnSubmit": {
            backgroundColor: "#f60",
            fontFamily: "Poppins,sans-serif !important",
            borderRadius: "0px",
            height: "58px",
            color: "white",
            "&:hover": {
              backgroundColor: "#ff5800",
            },
          },
          ".layout": {
            backgroundColor: "#FFF !important",
          },
          ".spanCardMediaRight span": {
            //Texto r-thea
            color: "#FF5800",
          },
          ".etiquetaUsuario": {
            display: "none",
          },
        },
      },
    },
  }),
  r: createMuiTheme({
    sidebar: {
      width: 280, // The default value is 240
    },
    palette: {
      primary: { main: "#444" },
      secondary: { main: "#444" },
    },
    overrides: {
      MuiMenuItem: {
        root: {
          whiteSpace: "normal",
        },
      },
      MuiCssBaseline: {
        "@global": {
          "@font-face": {
            fontFamily: "RGerstner",
            src: `local('RGerstner'),url(${RGerstner}) format('truetype')` /* Safari, Android, iOS */,
          },
          body: {
            fontFamily: "RGerstner",
          },
          ".localeBar": {
            backgroundColor: "#7f7f7f",
            height: "30px",
            paddingTop: "3px",
          },
          ".loginHeader": {
            backgroundColor: "#444",
          },
          ".logoHeader": {
            backgroundImage: `url(${logoR})`,
            backgroundSize: 40,
            width: 50,
          },
          ".login form .MuiCardActions-root": {
            margin: 50,
          },
          ".btnSubmit": {
            backgroundColor: "#f30",
            fontFamily: "Arial,sans-serif",
            fontSize: "18px",
            fontWeight: "normal !important",
            color: "white",
            "&:hover": {
              backgroundColor: "#f30",
            },
          },
          ".entradas": {
            borderRadius: "4px !important",
          },
          ".layout": {
            backgroundColor: "#FFF !important",
          },
          ".spanCardMediaRight span": {
            //Texto r-thea
            color: "#f30",
          },
          ".etiquetaEmailNifTelefono": {
            display: "none",
          },
          ".alrevesEnR": {
            flexDirection: "row-reverse",
          },
        },
      },
    },
  }),
  t: createMuiTheme({
    sidebar: {
      width: 280, // The default value is 240
    },
    palette: {
      primary: { main: "#0056bb" },
      secondary: { main: "#0056bb" },
    },
    overrides: {
      MuiMenuItem: {
        root: {
          whiteSpace: "normal",
        },
      },
      MuiCssBaseline: {
        "@global": {
          "@font-face": {
            fontFamily: "Telecable",
            src: `local('Telecable'),url(${Telecable}) format('truetype')`,
          },
          body: {
            fontFamily: "Telecable",
          },
          ".loginHeader": {
            backgroundColor: "#0056BB",
          },
          ".logoHeader": {
            backgroundImage: `url(${logoT})`,
            backgroundSize: 230,
            width: 250,
          },
          ".login form .MuiCardActions-root": {
            margin: 50,
          },
          ".btnSubmit": {
            backgroundColor: "#0056BB",
            fontFamily: "Telecable",
            borderRadius: "10px",
            padding: "18px",
            color: "white",
            minWidth: "120px !important",
            "&:hover": {
              backgroundColor: "#0056BB",
            },
          },
          ".layout": {
            backgroundColor: "#FFF !important",
          },
          ".spanCardMediaRight span": {
            //Texto r-thea
            color: "#ff7300",
          },
          ".etiquetaUsuario": {
            display: "none",
          },
          ".capitalizedInT": {
            textTransform:"capitalize !important",
          },
        },
      },
    },
  }),
  te: createMuiTheme({
    sidebar: {
      width: 280, // The default value is 240
    },
    palette: {
      primary: { main: "#0056bb" },
      secondary: { main: "#0056bb" },
    },
    overrides: {
      MuiMenuItem: {
        root: {
          whiteSpace: "normal",
        },
      },
      MuiCssBaseline: {
        "@global": {
          "@font-face": {
            fontFamily: "Telecable",
            src: `local('Telecable'),url(${Telecable}) format('woff')`,
          },
          body: {
            fontFamily: "Telecable",
          },
          ".loginHeader": {
            backgroundColor: "#0056BB",
          },
          ".logoHeader": {
            backgroundImage: `url(${logoT})`,
            backgroundSize: 230,
            width: 250,
          },
          ".horizontalLogoHeader": {
            backgroundImage: `url(${horizontalLogoTE})`,
            backgroundSize: 230,
            width: 250,
          },
          ".login form .MuiCardActions-root": {
            margin: 50,
          },
          ".btnSubmit": {
            backgroundColor: "#0056BB",
            fontFamily: "Telecable",
            borderRadius: "10px",
            padding: "18px",
            color: "white",
            fontSize: "1.04rem",
            minWidth: "120px !important",
            "&:hover": {
              backgroundColor: "#0056BB",
            },
          },
          ".layout": {
            backgroundColor: "#FFF !important",
          },
          ".spanCardMediaRight span": {
            //Texto r-thea
            color: "#ff7300",
          },
          ".etiquetaUsuario": {
            display: "none",
          },
          ".capitalizedInT": {
            textTransform:"capitalize !important",
          },
        },
      },
    },
  }),
  m: createMuiTheme({
    sidebar: {
      width: 280, // The default value is 240
    },
    palette: {
      primary: { main: "#ffe200" },
      secondary: {
        contrastText: "#fff",
        main: "#000000",
      },
      info: { main: "#43aa00" },
    },
    typography: {
      fontFamily: "Walsheim"
    },

    overrides: {
      MuiMenuItem: {
        root: {
          whiteSpace: "normal",
        },
      },
      RaReferenceField: {
        link: {
          color: "#2365fa",
        }
      },
      RaLink: {
        link: {
          color: "#2365fa",
        }
      },
      RaDeleteWithConfirmButton: {
        deleteButton: {
          backgroundColor:"#43aa00",
          color:"white !important",
          '&:hover':{
            backgroundColor: "#44960e",
            color:"white",
          },
        }
      },
      RaBulkDeleteWithUndoButton: {
        deleteButton:{
          backgroundColor:"#43aa00",
          color:"white !important",
          '&:hover':{
            backgroundColor: "#44960e",
            color:"white",
          },
        }
      },
      RaConfirm: {
        confirmPrimary:{
          color: "#43aa00",
        }
      },
      RaLogout: {
        icon: {
          color:"black",
        },
        menuItem: {
          backgroundColor:"#FFE200",
          color:"black",
        },
      },
      MuiCssBaseline: {
        "@global": {
          "@font-face": [
              {
                fontFamily: "Walsheim",
                src: `local('Walsheim'),url(${WalsheimBold}) format('truetype')`,
                fontWeight: "bold",
              },
              {
                fontFamily: "Walsheim",
                src: `local('Walsheim'),url(${WalsheimMedium}) format('truetype')`,
                fontWeight: "normal",
              }
          ]
          ,

          body: {
            fontFamily: "Walsheim !important",
          },
          ".localeBar": {
            backgroundColor: "#ffffff",
            height: "30px",
            paddingTop: "3px",
          },
          ".loginHeader": {
            backgroundColor: "#000000",
          },
          ".logoHeader": {
            backgroundImage: `url(${logoM})`,
            backgroundSize: 180,
            width: 200,
          },
          ".login form .MuiCardActions-root": {
            margin: 50,
          },
          ".btnSubmit": {
            backgroundColor: "#43aa00",
            textTransform:"uppercase !important",
            fontFamily: "Walsheim !important",
            fontWeight: "bold",
            fontSize: "medium",
            borderRadius: "0px",
            height: "58px",
            color: "white",
            "&:hover": {
              backgroundColor: "#44960e",
            },

          },
         
          ".layout": {
            backgroundColor: "#FFF !important",
          },
          ".spanCardMediaRight span": {
            //Texto r-thea
            padding: "5px",
            backgroundColor: "#ffe200",
            textTransform: "uppercase",
          },
          ".spanCardMediaLeft span": {
            textTransform: "uppercase",
          },
          ".etiquetaUsuario": {
            display: "none",
          },
          ".MuiButton-root.Mui-disabled": {
            opacity:0.4,
            color:"white",
            backgroundColor:"#43aa00",
          },
          ".MuiButton-textPrimary": {
            color:"#43aa00",
            "&:hover": {
              color:"#56da00",
            },
            "&.Mui-disabled": {
              backgroundColor:"transparent",
              opacity: 0.4,
            }
          },

          ".MuiButton-containedPrimary": {
            backgroundColor:"#43aa00",
            color:"white",
            "&:hover": {
              backgroundColor: "#44960e",
              color:"white",
            },
          },
          ".MuiTableCell-head": {
            fontWeight:"bold !important",
          },
          ".MuiAlert-standardInfo": {
            color: "#43aa00 !important",
            border: "1px solid #43aa00",
            margin: "8px 0px",
            display: "flex",
            padding: "8px 16px",
            backgroundColor: "#fafafa !important",
            alignItems: "center",
          },
          ".MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
              borderColor:"black !important",
            }
          },
          ".MuiFormLabel-root": {
            "&.Mui-focused": {
              color:"black !important",
            }
          },
          ".MuiMenu-list": {
            backgroundColor: "#FFE200",
            color:"black",
          }

        },
      },
    },
  }),
  error: createMuiTheme({
    overrides: {
      MuiCssBaseline: {
        "@global": {
          ".login form": {
            display: "none",
          },
          ".errorContainer": {
            display: "flex!important",
            textAlign: "center",
          },
        },
      },
      ".btnSubmit": {
        backgroundColor: "#0056BB",
      },
    },
  }),
};
